import { render, staticRenderFns } from "./AddressSelect.vue?vue&type=template&id=32e18702&scoped=true&"
import script from "./AddressSelect.vue?vue&type=script&lang=js&"
export * from "./AddressSelect.vue?vue&type=script&lang=js&"
import style0 from "./AddressSelect.vue?vue&type=style&index=0&id=32e18702&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e18702",
  null
  
)

export default component.exports